import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import makeStyles from "@material-ui/core/styles/makeStyles"

import DialogMui from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import Typography from "@material-ui/core/Typography"
import Box from "@material-ui/core/Box"
import FormControl from "@material-ui/core/FormControl"
import Button from "@material-ui/core/Button"
import Skeleton from "@material-ui/lab/Skeleton"

import AvatarInput from "./AvatarInput"
import { DialogTitle } from "components/partials"
import { useAppSelector, useIsInputWritable } from "common/hooks"
import { CompaniesApi } from "common/api"
//import { UsersSummary } from "components/pages/companies/admin/Table/Users"
//import { SuccessButton } from "components/widgets"
import { Alert } from "components/widgets"
//import { LocalStorageKey } from "common/helpers"
//import { useLocalStorage } from "common/hooks"
import { Role } from "common/types/user.type"
//import axios from "axios"

const useStyles = makeStyles(theme => ({
	info: {
		display: "flex",
		gap: theme.spacing(2)
	},

	userSummary: {
		display: "flex",
		alignItems: "center",
		columnGap: theme.spacing(1),

		"& .MuiTypography-root": {
			flexShrink: 0
		}
	}
}))

const CompanyModal = props => {
	const { t } = useTranslation()

	const auth = useAppSelector(state => state.auth)
	const company = auth.user?.company

	//const [user, setUserInLocalStorage] = useLocalStorage(LocalStorageKey.User)
	const isWritable = useIsInputWritable()

	const [companyInfo, setCompanyInfo] = useState(null)
	//const [isSaving, setIsSaving] = useState(false)
	const [alert, setAlert] = useState(null)

	useEffect(() => {
		if (company?.id && props.open) {
			CompaniesApi.getOne(company.id).then(response => {
				setCompanyInfo(response.data)
			})
		}
	}, [company?.id, props.open])

	function onClose() {
		if (props.onClose) {
			props.onClose({}, "backdropClick")
		}
	}

	function onChangeProfile(base64Image) {
		if (companyInfo) {
			setCompanyInfo({ ...companyInfo, profileImage: base64Image })
		}
	}

	/*
	async function onSave() {
		try {
			setIsSaving(true)
			const response = await CompaniesApi.update(companyInfo)
			setUserInLocalStorage({ ...user, company: response.data })
			setAlert({
				severity: "success",
				text: t("general.components.companyModal.success")
			})
		} catch (error) {
			if (axios.isAxiosError(error) && error.response?.status === 403) {
				setAlert({
					severity: "error",
					text: t("errors.insufficientPermission")
				})
			} else {
				setAlert({
					severity: "error",
					text: t("general.components.companyModal.error")
				})
			}
		} finally {
			setIsSaving(false)
		}
	}
	*/

	function onExited() {
		setAlert(null)
	}

	return (
		<DialogMui
			{...props}
			maxWidth="sm"
			TransitionProps={{
				onExited: onExited
			}}
		>
			<DialogTitle onClose={onClose}>
				{t("general.components.companyModal.title")}
			</DialogTitle>

			<DialogContent>
				{alert && (
					<Alert marginBottom={1} severity={alert.severity}>
						{alert.text}
					</Alert>
				)}

				{companyInfo ? (
					<Content company={companyInfo} onChangeProfile={onChangeProfile} />
				) : (
					<Loader />
				)}
			</DialogContent>

			<DialogActions>
				{isWritable(Role.Admin) && (
					<>
						<Button onClick={onClose}>
							{t("general.components.companyModal.cancel")}
						</Button>
						{/* 
            <SuccessButton
              autoFocus
              variant="contained"
              color="primary"
              disabled={isSaving}
              onClick={onSave}
            >
              {isSaving
                ? t("general.components.companyModal.submitButtonLoading")
                : t("general.components.companyModal.submitButton")}
            </SuccessButton>
            */}
					</>
				)}
			</DialogActions>
		</DialogMui>
	)
}

const Content = props => {
	const { t } = useTranslation()

	const classes = useStyles()
	const { company, onChangeProfile } = props
	const {
		name,
		profileImage,
		//users,
		//unlimitedUserLicenses,
		//userLicenses,
		catalogs,
		totalOwnedCatalogs
	} = company
	const isWritable = useIsInputWritable()

	return (
		<Box className={classes.info}>
			<AvatarInput
				allowInput={isWritable(Role.Admin)}
				onChange={onChangeProfile}
				AvatarProps={{
					alt: name,
					src: profileImage || undefined
				}}
			/>

			<Box>
				<Typography variant="h5">{name}</Typography>

				{/*
        <FormControl fullWidth>
          <Typography>
            {unlimitedUserLicenses
              ? t("general.components.companyModal.totalUsers", {
                total: users.length
              })
              : t("general.components.companyModal.totalUsersOverLicenses", {
                total: users.length,
                licenses: userLicenses
              })}
          </Typography>

          <Box className={classes.userSummary}>
            <UsersSummary users={users} />
          </Box>
        </FormControl>
        */}

				<FormControl fullWidth margin="normal">
					<Typography>
						{t("general.components.companyModal.catalogsOwned", {
							total: catalogs.length,
							totalOwned: totalOwnedCatalogs
						})}
					</Typography>
				</FormControl>
			</Box>
		</Box>
	)
}

const Loader = () => {
	const classes = useStyles()

	return (
		<Box className={classes.info}>
			<AvatarInput isLoading />

			<Box>
				<Skeleton width={300} height={35} />

				<FormControl fullWidth>
					<Skeleton width="50%" />

					<Box className={classes.userSummary}>
						<Skeleton width="30%" />
						<Skeleton width="30%" />
						<Skeleton width="30%" />
					</Box>
				</FormControl>

				<FormControl fullWidth margin="normal">
					<Skeleton width={100} />
				</FormControl>
			</Box>
		</Box>
	)
}

export default CompanyModal
